import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=c6eb2d7a&scoped=true"
import script from "./RoleCreate.vue?vue&type=script&lang=js"
export * from "./RoleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6eb2d7a",
  null
  
)

export default component.exports